import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthStore } from "../store/authStore";
import Loading from "./Loading";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoggedOut, loadingPage } = useAuthStore();
  const location = useLocation();
  const isPreview = process.env.REACT_APP_UI_PREVIEW === "true";

  if (isPreview) {
    return <Outlet />;
  }

  if (loadingPage) {
    return <Loading variant="table" />;
  }

  if (isLoggedOut || !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};
export default ProtectedRoute;
